module.exports = __webpack_public_path__ + "img/Support-skill-322.0c2c4635.png";